var _defs, _rect, _rect2, _rect3, _path, _g, _g2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultNoteCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 724",
    role: "img",
    "aria-label": "Default drill cover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coverBg",
    x1: 70,
    y1: 36,
    x2: 454,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#243f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#303626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b2f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coverGlow",
    x1: 142,
    y1: 114,
    x2: 382,
    y2: 492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ec4b6",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ffd66b",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7a59",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#000000",
    floodOpacity: 0.32
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 724,
    rx: 22,
    fill: "#18120f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 456,
    height: 668,
    rx: 18,
    fill: "url(#coverBg)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 456,
    height: 668,
    rx: 18,
    fill: "url(#coverGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 94h340M86 630h340",
    stroke: "#ffe5c2",
    strokeOpacity: 0.12,
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22,
    stroke: "#ffe5c2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 144h280M116 190h280M116 236h280M116 282h280M116 328h280"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 184,
    width: 236,
    height: 304,
    rx: 18,
    fill: "#241915",
    fillOpacity: 0.64,
    stroke: "#ffd66b",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 220h118c28 0 50 22 50 50v186H220c-30 0-54-24-54-54V244c0-13 11-24 24-24z",
    fill: "#ffe5c2",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 256h102M204 298h94M204 340h120M204 382h78",
    stroke: "#ffd66b",
    strokeOpacity: 0.5,
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 244c0-13 11-24 24-24h36v236h-6c-30 0-54-24-54-54V244z",
    fill: "#2ec4b6",
    fillOpacity: 0.18
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 570,
    textAnchor: "middle",
    fill: "#ffe5c2",
    fillOpacity: 0.72,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 42,
    fontWeight: 900,
    letterSpacing: 8
  }, "DRILL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 610,
    textAnchor: "middle",
    fill: "#ffd66b",
    fillOpacity: 0.62,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 800,
    letterSpacing: 5
  }, "REP &amp; SPEAK")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultNoteCover);
export default __webpack_public_path__ + "static/media/default-note-cover.d82dfac4baf276c8d65bea390075cdb5.svg";
export { ForwardRef as ReactComponent };